import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class AnaliseKeys extends MainKeys {
    get place() {
        return Places.analise
    }

    public get analiseId() {
        return this._intent.getParameterAsNumber(ParamIds.analiseFormId)
    }

    public set analiseId(value: number | undefined) {
        this._intent.setParameter(ParamIds.analiseFormId, value)
    }
}

export default AnaliseKeys
